<template>
  <div id="app">
    <div class="header" v-show="type === 'KEE'"><img src="./assets/banner-new.png" alt="AUTOMOTIVE & ENERGY WEBINAR SERIES"></div>
    <div class="header" v-show="type === 'KTS'"><img src="./assets/kts/banner-newkts.png" alt="AUTOMOTIVE & ENERGY WEBINAR SERIES"></div>
    <!--tab切换-->
    <div class="tabBg" :class="type==='KTS'?'tabBgkts':''" v-if="!isWap">
      <p @click="typeChange('KEE')">KEE</p>
      <p @click="typeChange('KTS')">KTS</p>
    </div>
    <div class="container pc" v-if="!isWap">
      <webinar-list/>
      <div class="container__right">
        <login :screenWidth="screenWidth"/>
        <webinar-details/>
        <About :screenWidth="screenWidth"/>
      </div>
    </div>
    <div class="container wap" v-if="isWap">
      <!--tab切换-->
      <div class="tabBg" :class="type==='KTS'?'tabBgkts':''">
        <p @click="typeChange('KEE')">KEE</p>
        <p @click="typeChange('KTS')">KTS</p>
      </div>
      <webinar-list/>
      <About :screenWidth="screenWidth" />
      <div class="commonProblem_wap">
        <a href="https://kee.smarket.net.cn/2019/question.html" target="_blank">
          <img src="./assets/CommonProblem.png" alt="常见问题">
        </a>
      </div>
    </div>
    <div class="commonProblem" v-if="!isWap">
      <a href="https://kee.smarket.net.cn/2019/question.html" target="_blank">
        <img src="./assets/commonProblem.jpg" alt="常见问题">
      </a>
    </div>
    <div class="backToTop" v-if="isWap" v-show="isShowToTop && isRegistering == 0" @click="backToTop">
      <img src="./assets/backToTop.png" alt="">
    </div>
    <div class="footer">
      是德的隐私权声明，<br v-if="isWap">请参见 <a href="//www.keysight.com/key/privacy" target="_blank">www.keysight.com/key/privacy</a>.
      ,它阐述了是德对隐私权保护的承诺。如对是德隐私权声明存有任何疑问，<br>
      请联系 privacy_advocate@keysight.com 或者Privacy Advocate - Keysight Technologies - 1400 Fountaingrove Pkwy - Santa
      Rosa, CA 95403-6493 - USA<br>
      © 是德科技 2018 <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备11038982号-10</a>
    </div>
    <register :screenWidth="screenWidth" :setTop="setTop"/>
    <Toast/>
    <loading/>
  </div>
</template>

<script>
  import WebinarList from './components/WebinarList';
  import WebinarDetails from './components/WebinarDetails';
  import Login from './components/Login';
  import Register from './components/Register';
  import About from './components/About';
  import Toast from './components/Toast';
  import Loading from './components/Loading';
  import {setCookie, getCookie, removeCookie} from './utils/public';
  import VueCookies from 'vue-cookies'
  import bus from './utils/eventBus';
  export default {
    name: 'app',
    data() {
      return {
        screenWidth: $(document).width(), // 屏幕尺寸
        setTop: '0',
        isShowToTop: false,
        s_top: 0,
        s_top1: 0,
        type: '',
      };
    },
    created() {
      this.type = smarket.urlParams.type?smarket.urlParams.type.toUpperCase() :'KEE';
      this.$store.commit('setType', this.type);
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        return (() => {
          that.screenWidth = $(document).width();
        })();
      };
      $.cookie('ARC',smarket.urlParams.ARC?smarket.urlParams.ARC:'',{ expires: 7, path: '/' });
      $(window).on('scroll', this.handleScroll);
      $(window).on('resize', function() {
        if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
          window.setTimeout(function() {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      });
        console.log(VueCookies.get("isKeeAutoLogin"));
      let mobile =decodeURIComponent(VueCookies.get("isKeeAutoLogin")?VueCookies.get("isKeeAutoLogin"):'') ;
      //const sess = $.cookie('sess') || '';
      if(mobile){
        this.doLogin(mobile);
      }
      else{
          let smarketInfo=smarket.cookie.smarketMember(window.config.schemaId);
          if(smarketInfo&&smarketInfo["formData"]){
              smarketInfo["formData"].forEach(item=>{
                  if(item.fieldName=="email"){
                      mobile=item.value;
                  }
              })
          }
          if(mobile){
              this.doLogin(mobile);
          }
      }
    },
    computed: {
      isWap() {
        return $(document).width() <= 750;
      },
      loginStatus() {
        return this.$store.state.loginStatus;
      },
      isRegistering() {
        return this.$store.state.isRegistering;
      },
      // type(){
      //   return this.$store.state.type;
      // }
    },
    watch: {
      loginStatus: function(val, oVal) {
        $(document).scrollTop(0);
      },
      isRegistering: function(val) {
        if (val === 1) {
          this.s_top1 = this.s_top;
          $('html,body').css({
            height: '100%',
            overflow: 'hidden'
          });
          // $('body').scrollTop(this.s_top);
        } else {
          $('html,body').css({
            height: 'auto',
            overflow: 'visible'
          });
          // $(window).scrollTop(this.s_top1);
        }
      },
      type:function (val) {
        this.type = val;
      }
    },
    components: {
      WebinarList,
      WebinarDetails,
      Login,
      Register,
      About,
      Toast,
      Loading,
    },
    methods: {
      handleScroll: function() {
        if (this.screenWidth < 750) {
          this.s_top = $(document).scrollTop();
          this.setTop = 0;
          this.isShowToTop = $(document).scrollTop() > 0;
        }
      },
      backToTop: function() {
        $(document).scrollTop(0);
      },
      doLogin: function(mobile) {
        var _self = this;
        $.ajax({
          url: window.config.api.gateway.general + '/member/login',
          type: 'post',
          dataType: 'json',
          data: {
            'tenantId': window.config.tenantId,
            'schemaId': window.config.schemaId,
            'memberFormId': window.config.formId,
            'memberSchemaId': window.config.schemaId,
            'unique': mobile,
            'token': '',
            'password': '96E79218965EB72C92A549DD5A330112',
            'checkCode': '',
            'loginType': '',
            'globalUserId': ''
          },
          success: function(e) {
            // console.log(e);
            if (e.body.desc == 'successful') {
              setCookie('globalUserId', e.body.content.session, 7);
                let formDataKey=window.config.formDataKey;
                let data = e.body;
                let formData = [];
                if (data['content'] && data['content']['info']) {
                    formDataKey.forEach(function (key) {
                        var obj = {
                            'fieldName': key,
                            'value': data['content']['info'][key]
                        };
                        formData.push(obj);
                    });
                }
                smarket.cookie.smarketMember(window.config.schemaId, {
                    session: e.body.content.session,
                    memberId: e.body.content.memberModel.memberId,
                    formData:formData,
                    name:data['content']['info']['name'] || '',
                    registerTime:data['content']['memberModel']['createTime'] || ''
                }, {expires: 7});
              setCookie('sess', e.body.content.sess, 7);

              setCookie('username', e.body.content.memberModel.unique, 7);
              if (!e.body.content.memberModel.hasOwnProperty('isKEE') || !e.body.content.memberModel.isKEE) {
                $.ajax({ //更新字段
                  url: window.config.api.gateway.general + '/api/member/contacts/info/update',
                  type: 'post',
                  dataType: 'json',
                  data: {
                    'memberFormId': window.config.formId,
                    'sess': e.body.content.sess,
                    'formData': [{fieldName: 'isKEE', value: '是'}]
                  },
                  success: function(e) {

                  }
                });
              }
              let requiredUpdate = false;
              const requiredField = window.config.requiredField;
              requiredField.forEach( item => {
                if(!e.body.content.memberModel[item] && !requiredUpdate) {
                  requiredUpdate = true;
                }
              })
              //是否跳转信息补全页
                let isSignUpFlag=false;
                $.ajax({ //更新字段
                    url: window.config.api.gateway.general + '/api/webinar/contacts/login',
                    type: 'post',
                    async:false,
                    dataType: 'json',
                    data: {
                        "webinarId":"38379",
                        'tenantId': window.config.tenantId,
                        'value':_self.login_name,
                        'sess': e.body.content.sess,
                    },
                    success: function(signUpData) {
                        if(signUpData.body.result==0){
                            isSignUpFlag=signUpData.body.content.isSignUp == 1 ? true : false;
                        }
                    }
                });
              if(requiredUpdate&&!isSignUpFlag){
                // _self.$store.commit('setIsRegistering', 2);
                // _self.$store.commit('setUserInfo', e.body.content.memberModel);
                window.location.href = 'https://kee.smarket.net.cn/register/index.html#/updateUser';
              }else{
                _self.login_name = '';
                _self.$store.commit('setLoginStatus', 1);
                _self.$store.commit('setUserInfo', e.body.content.memberModel);
                bus.$emit('showToast', '登录成功');
                // $.Huimodalalert('登录成功',2000);
              }
            } else {
              _self.noRegShow = true;
            }
          }
        });
      },
      //TAB切换事件
      typeChange(e){
        this.$store.commit('setType', e);
        this.type = e;
      }
    }
  };
</script>

<style lang="scss">
  body {
    min-height: 100vh;
    background-color: #fff;
    font: 14px/1.42857 "Microsoft YaHei", "Helvetica Condensed", "Helvetica Neue", Avenir, Helvetica, Arial, sans-serif;
    color: #fff;

    * {
      box-sizing: border-box;
    }
  }

  #app {
    position: relative;
    min-height: 100vh;
    color: #2c3e50;
    overflow: hidden;
    margin: 0 auto;
    min-width: 1200px;
  }

  %container {
    width: 1200px;
    margin: 0 auto;
  }

  .header {
    @extend %container;
    padding-bottom: 3px;

    > img {
      display: block;
      width: 100%;
    }
  }

  .tabBg{
    background:url("assets/kts/tabbg-kee.png") no-repeat center center;
    background-size: 1200px 55px;
    width: 1200px;
    height: 55px;
    margin: 22px auto 25px;
    p{
      width: 345px;
      line-height: 55px;
      font-size: 30px;
      font-weight: bold;
      float: left;
      padding: 0;
      margin: 0;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
    p:last-child{
      width: 315px;
    }
  }
  .tabBgkts{
    background:url("assets/kts/tabbg-kts.png") no-repeat center center;
    background-size: 1200px 55px;
  }

  .container {
    &.pc {
      @extend %container;
      padding-bottom: 238+24px;
      display: flex;

      .container__right {
        flex: 0 0 46%;
        width: 46%;
        overflow: hidden;
      }
    }
  }

  .commonProblem {
    position: fixed;
    right: 0;
    top: 60%;
    z-index: 999;

    img {
      display: block;
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 238px;
    margin-top: 24px;
    padding-top: (238-32*3-10px)/2;
    line-height: 32px;
    font-size: 16px;
    text-align: center;
    background-color: #efefef;
    color: #524f56;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  /*WAP端*/
  @media screen and (max-width: 750px) {
    #app {
      width: 100%;
      min-width: 0;
      position: relative;

      .backToTop {
        position: fixed;
        right: pxToRem(28);
        bottom: pxToRem(100);
        background-color: #fff;
        z-index: 9999;
        height: pxToRem(88);

        img {
          width: pxToRem(88);
        }
      }
    }

    %container {
      width: 100%;
      margin: 0 auto;
    }

    .container {
      &.wap {
        padding-bottom: pxToRem(319);
      }
    }

    .tabBg{
      background:url("assets/kts/tabbg-kee-wap.png") no-repeat center center;
      background-size: pxToRem(680) pxToRem(70);
      width: pxToRem(680);
      height: pxToRem(70);
      p{
        width: pxToRem(310);
        line-height: pxToRem(70);
        font-size: pxToRem(46);
      }
      p:last-child{
        width: pxToRem(270);
      }
    }
    .tabBgkts{
      background:url("assets/kts/tabbg-kts-wap.png") no-repeat center center;
      background-size: pxToRem(680) pxToRem(70);
    }


    .commonProblem_wap {
      height: pxToRem(115);
      padding: pxToRem(17) pxToRem(30) pxToRem(18);
      color: #ea2331;

      &:after {
        content: '';
        display: block;
        clear: both;
      }

      > a {
        color: inherit;
        text-decoration: none;
        position: relative;
        padding: pxToRem(23) 0;
        float: right;

        img {
          display: block;
          height: pxToRem(34);
        }
      }
    }

    .footer {
      height: pxToRem(319);
      margin-top: 0;
      padding: pxToRem(20) pxToRem(35) 0;
      line-height: pxToRem(36);
      font-size: pxToRem(22);
      text-align: center;
      background-color: #efefef;
      color: #524f56;
    }
  }
</style>
